var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"room-locked main-container"},[_c('div',{staticClass:"container--slim"},[_c('h1',[_vm._v(_vm._s(_vm.$t('conference_room_locked_headline')))]),_c('div',[_vm._v(" "+_vm._s(_vm.$t('conference_room_locked_text'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }